// extracted by mini-css-extract-plugin
var _1 = "PostStateBarOverflowMenu-module__animateUploadProgressBarWidth--dLPD3";
var _2 = "PostStateBarOverflowMenu-module__animatedBackground--StaB6";
var _3 = "PostStateBarOverflowMenu-module__button--N_MX_";
var _4 = "PostStateBarOverflowMenu-module__isOpen--XgvHC";
var _5 = "PostStateBarOverflowMenu-module__muted--sOgPw";
var _6 = "PostStateBarOverflowMenu-module__success--qeYgh";
var _7 = "PostStateBarOverflowMenu-module__warning--NiuTI";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "isOpen", _5 as "muted", _6 as "success", _7 as "warning" }
